import Dexie from 'dexie';

const db = new Dexie('arctangent');
db.version(1).stores({
    schedule: 'name'
})

export default db;